<template>
  <div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <CCol sm="12">
                    <!-- Name -->
                    <CRow>
                        <CCol sm="12">
                            <CInput label="Nome*" placeholder="" v-model="tool.name" :is-valid="nameValidator"/>
                        </CCol>
                    </CRow>
                    <!-- Notes -->
                    <CRow>
                        <CCol sm="3">
                            <label class="">Imagem</label>
                            <div title="Choose an image"
                                class="base-image-input"
                                :style="{ 'background-image': `url(${imageData})` }"
                                @click="chooseImage"
                                v-bind:class="{'is-invalid': genericValidator() == false}">
                                <span
                                v-if="!imageData"
                                class="placeholder"
                                >
                                Escolher imagem
                                </span>
                                <input
                                class="file-input"
                                ref="fileInput"
                                type="file"
                                @change="onSelectFile"
                                >
                            </div>
                        </CCol>
                        <CCol sm="9">
                            <CTextarea label="Notas" placeholder="" vertical v-model="tool.notes" rows="12"  :is-valid="genericValidator()"/>
                        </CCol>
                    </CRow>
                    <!-- Attributes -->
                    <CRow class="mt-2">
                        <CCol sm="10">
                            <hr/>
                        </CCol>
                        <CCol sm="2" class="d-flex justify-content-end">
                            <CButton color="primary" variant="outline" square size="sm" @click="addAttribute">
                                Adicionar atributo
                            </CButton>
                        </CCol>
                    </CRow>
                    <CCol>
                        <CRow v-for="(attribute, index) in tool.attributes" :key="index" class="attribute-info d-flex align-items-end mb-3 mt-3"  v-bind:class="{'remove-attribute': tool.removedAttributes && tool.removedAttributes.includes(attribute.id)}">
                            <!-- Name -->
                            <CInput class="mr-2 mb-0 flex-grow-1" label="Nome*" placeholder="" v-model="attribute.name" :is-valid="nameValidator(attribute.name)" :readonly="Boolean(attribute.id)"/>
                            <!-- -->
                            <!-- Type -->
                            <CButton v-if="!tool.removedAttributes || !tool.removedAttributes.includes(attribute.id)" class="type-button mr-1" sm="4" color="primary" variant="outline" square size="sm" v-bind:class="{'selected': attribute.type == textTypeId}" @click="attribute.type = textTypeId" :disabled="Boolean(attribute.id)">
                                Texto
                            </CButton>
                            <CButton v-if="!tool.removedAttributes || !tool.removedAttributes.includes(attribute.id)" class="type-button mr-1" sm="4" color="primary" variant="outline" square size="sm" v-bind:class="{'selected': attribute.type == numberTypeId}" @click="attribute.type = numberTypeId" :disabled="Boolean(attribute.id)">
                                Número
                            </CButton>
                            <CButton v-if="!tool.removedAttributes || !tool.removedAttributes.includes(attribute.id)" class="type-button mr-1" sm="4" color="primary" variant="outline" square size="sm" v-bind:class="{'selected': attribute.type == booleanTypeId}" @click="attribute.type = booleanTypeId" :disabled="Boolean(attribute.id)">
                                Sim/Não
                            </CButton>
                            <!-- Remove -->
                            <CButton v-if="!tool.removedAttributes || !tool.removedAttributes.includes(attribute.id)" class="ml-3 action-attribute" color="primary" variant="outline" square size="sm" @click="onRemoveClicked(attribute)">
                                Remover
                            </CButton>
                            <CButton v-else class="ml-3 action-attribute" color="primary" variant="outline" square size="sm" @click="onCancelRemoveClicked(attribute)">
                                Adicionar
                            </CButton>
                        </CRow>
                    </CCol>
                    <!-- Action button -->
                    <CCol class="d-flex justify-content-end mt-3">
                        <CRow sm="2" class="align-self-end">
                            <CSpinner v-if="loading" variant="success" small></CSpinner>
                            <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">Submeter</CButton>
                        </CRow>
                    </CCol>
                </CCol>
            </CCardBody>
        </CCard>
    </CCol>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Tool from "@/classes/Tool";
import InputTool from "@/classes/InputTool";
import { UTILS_HELPER } from "@/helpers/utils.js";
import Attribute from "@/classes/Attribute";

const TEXT_TYPE_ID = 0;
const NUMBER_TYPE_ID = 1;
const BOOLEAN_TYPE_ID = 2;

export default {
    props:{    
        baseTool:
        {
            type: Object,
            default: null
        }
    },
    data()
    {
        return {
            textTypeId: TEXT_TYPE_ID,
            numberTypeId: NUMBER_TYPE_ID,
            booleanTypeId: BOOLEAN_TYPE_ID,
            //
            imageData: '', // The direct binding to tool.path was not working correctly
            submitted: false,
            tool: new Tool(),
            loading: false
        }
    },
    mounted: function()
    {
        this.resetTool();
    },
    computed:
    {
        ...mapState('alert', ['type']),
        ...mapState('alert', ['message'])
    },
    methods:{
        chooseImage () {
            this.$refs.fileInput.click();
        },   
        onSelectFile () {
            const input = this.$refs.fileInput;
            const files = input.files;
            if (files && files[0]) {
                const reader = new FileReader();
                reader.onload = e => {
                this.imageData = e.target.result;
                }
                reader.readAsDataURL(files[0]);
            }
        },
        resetTool(){
            if(!this.baseTool)
            {
                this.tool = new Tool(null, null, null, []);
            }
            else
            {
                this.tool = UTILS_HELPER.deepClone(new Tool, this.baseTool);

                this.tool.attributes = [];
                this.baseTool.attributes.forEach(attribute => {
                    this.tool.attributes.push(UTILS_HELPER.deepClone(new Attribute, attribute));
                });

                this.tool.removedAttributes = []; 
            }

            this.imageData = this.tool.photoPath;
        },
        submitClicked(){
            this.submitted = true;

            // Emit event
            if(this.tool.isValid())
            {
                var input = new InputTool(null, this.tool, this.$refs.fileInput.files[0]);

                if(this.baseTool && this.$route.params.id)
                {
                    input.id = this.$route.params.id;
                }

                this.loading = true;
                this.$emit('submit-requested', input);
            }
        },
        genericValidator(){
            var result = undefined; // This is the default, in case the user hasn't submitted yet

            // Validate error
            if(this.submitted && this.addError)
            {
                result = false;
            }

            return result;
        },
        nameValidator(val){
            var result = this.genericValidator();

            if(this.submitted && result != false)
            {
                if(!val)
                {
                    val = this.tool.name;
                }

                result = Boolean(val);
            }

            return result;
        },
        addAttribute()
        {
            var attribute = new Attribute(null, null, TEXT_TYPE_ID);
            this.tool.attributes.push(attribute);
        },
        onRemoveClicked(attribute)
        {
            if(!attribute.id)
            {
                this.tool.attributes.splice(this.tool.attributes.indexOf(attribute), 1);
            }
            else
            {
                this.tool.removedAttributes.push(attribute.id);
            }
        },
        onCancelRemoveClicked(attribute)
        {
            this.tool.removedAttributes.splice(this.tool.removedAttributes.indexOf(attribute.id), 1);
        },
        getAttributeTypeName(attribute)
        {
            var result = '';

            switch(attribute.type)
            {
                case TEXT_TYPE_ID:
                {
                    result = "Texto";
                    break;
                }
                case NUMBER_TYPE_ID:
                {
                    result = "Número";
                    break;
                }
                case BOOLEAN_TYPE_ID:
                {
                    result = "Sim/Não";
                    break;
                }
            }
            
            return result;
        }
    },
    watch:
    {
        baseTool: function(val)
        {
            this.resetTool();
        },
        type: function()
        {
            this.addError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        },
        message: function()
        {
            this.addError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        }
    }
}
</script>

<style>
.base-image-input {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}

.placeholder {
  background: #F0F0F0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: Helvetica;
}

.placeholder:hover {
  background: #E0E0E0;
}

.file-input {
  display: none;
}

img
{
  width: 50%;
  height: 50%;
}

.base-image-input.is-invalid > span
{
  background-color: #e55353;
  color: white;
}

.attribute-info > button
{
    height: 35px;
}

.type-button
{
    min-width: 80px;
}

.type-button.selected
{
    color: #fff;
    background-color: #2a1ab9;
    border-color: #2819ae;
}

.remove-attribute input
{
    color: white;
    background-color: gray !important;
}
.action-attribute
{
    min-width: 65px;
}
</style>